import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests.js'

import SetTitle from '../components/shared/SetTitle.js';
import HelpText from '../components/help/HelpText.js';
import TypeOfPersonSelect from '../components/shared/TypeOfPersonSelect';

import { adminUser, managerUser, capitalizeAllWords, renderErrors } from '../utilities/Forms.js'
import { debounce, formatDate, hideResidentsCheck, TYPE_OF_PEOPLE } from '../utilities/Generic.js'

class ArrivalsForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handlePersonSearch = this.handlePersonSearch.bind(this);
    this.debouncedHandleSearch = debounce(this.handlePersonSearch, 500);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    search: "",
    type_of_person: "",
    person_id: this.props.person_id || "",
    reported_check_in: formatDate(new Date(), 0) + "T00:00",
    reported_check_out: "",
    location_id: this.props.locations[0].id,

    hideResidents: hideResidentsCheck(),

    people: [],

    peopleLoaded: true,
    unauthorized: "",
    errors: "",
    error: "",
    updating: false
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleSearchChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    if (name === "search") {
      this.setState({peopleLoaded: false});
      this.debouncedHandleSearch(event)
    }
    else {
      this.handlePersonSearch(event)
    }
  }

  handlePersonSearch(event) {
    if (this.state.search === "") {
      this.setState({
        peopleLoaded: true
      })

      return
    }

    let dataObject = {
      search: this.state.search,
      type_of_person: this.state.type_of_person
    }

    let name = event.target.name;
    let value = event.target.value;

    dataObject[name] = value

    let params = `person[partial]=${dataObject.search}`

    if (dataObject.type_of_person) {
      params += `&person[type]=${dataObject.type_of_person}`
    }

    if (this.state.location_id) {
      params += `&person[location]=${this.state.location_id}`
    }

    request("GET", `/v1/a/people/scoped_names_and_ids?${params}`, null, () => { this.setState({ unauthorized: true }) })
      .then(data => {
        const people = data.filter(person => person.id.toString() !== this.props.other_person_id)

        this.setState({ people: people, peopleLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, peopleLoaded: true })
      })
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = JSON.stringify({
      "event": {
        "person_id": this.state.person_id,
        "reported_check_in": this.state.reported_check_in,
        "reported_check_out": this.state.reported_check_out,
        "location_id": this.state.location_id
      }
    })

    request("POST", `/v1/a/events/manual_check_in`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", "Event created successfully!");

        this.props.closePanel()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderPersonSelect() {
    if (this.state.peopleLoaded === false) {
      return (
        <select name="person_id">
          <option value="">Loading...</option>
        </select>
      )
    }

    if (this.props.person_name) {
      return (
        <>
          <label className="column">Person:</label>{ renderErrors(this.state.errors, 'person_relationships.person', 'person') }
          <select name="person_id" disabled={true}>
            <option value="">{this.props.person_name}</option>
          </select>
        </>
      )
    }

    const { type_of_person, person_id, people, hideResidents } = this.state;

    let type_of_people = TYPE_OF_PEOPLE

    if (hideResidents) {
      type_of_people = type_of_people.filter(type_of_person => type_of_person !== "resident")
    }

    return (
      <select name="person_id" onChange={this.handleChange} value={person_id}>
        <option value="">Select</option>
        {type_of_people.map(current_type_of_person =>
          (type_of_person === current_type_of_person || !type_of_person) &&
          <optgroup label={capitalizeAllWords(current_type_of_person)} key={current_type_of_person}>
            {people.filter(person => person.type_of_person === current_type_of_person).map(person => (
              <option value={person.id} key={person.id}>{person.full_name}</option>
            ))}
          </optgroup>
        )}
      </select>
    )
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  render() {
    const { search, type_of_person, reported_check_in, reported_check_out, location_id, unauthorized, errors } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    return (
      <div>
        <SetTitle title="New Manual Arrival" />

        <form onSubmit={this.handleSubmit}>
          <div className="settings big-settings">
            {!this.props.person_id &&
              <>
                <label className="column">Type:</label>
                <TypeOfPersonSelect defaultText="All" value={type_of_person} onChange={this.handleSearchChange} />

                <div className="row">
                  <label className="column">Person:</label>{ renderErrors(errors, 'person', "") }
                  <input placeholder="Enter text to search" className="no-margin" type="text" name="search" value={search} onChange={this.handleSearchChange} />
                </div>

              </>
            }

            {this.renderPersonSelect()}

            <div className="row">
              <HelpText className="inline" page={'arrivals'} section={'reported_check_in'} />

              <label className="column">Arrived At:</label>{ renderErrors(errors, 'reported_check_in', "") }
              <input type="datetime-local" aria-required="true" name="reported_check_in" onChange={this.handleChange} value={reported_check_in} required />
            </div>

            {this.props.person_id &&
              <>
                <div className="row">
                  <HelpText className="inline" page={'arrivals'} section={'reported_check_out'} />

                  <label className="column">Left At: (optional)</label>{ renderErrors(errors, 'reported_check_out') }
                  <input type="datetime-local" name="reported_check_out" onChange={this.handleChange} value={reported_check_out} />
                </div>

                <div className="row">
                  <HelpText className="inline" page={'arrivals'} section={'location_id'} />

                  <label className="column">Location:</label>{ renderErrors(errors, 'location_id') }
                  <select name="location_id" onChange={this.handleChange} value={location_id}>
                    {this.props.locations.map((location) => (
                      <option value={location.id} key={location.id}>{location.name}</option>
                    ))}
                  </select>
                </div>
              </>
            }
          </div>

          <div className="settings big-settings">
            { this.renderSaveButton() }
          </div>
        </form>
      </div>
    );
  }
}

export default ArrivalsForm;
